import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toastError, toastSuccess } from "../../config/ToastModal";
import { AddDocumentDetails, AddDocumentMSME } from "../../services/auth";

function DocumentUploadBox({ profileData, servicesList }) {
  const [logoImgPreview, setLogoImgPreview] = useState(null);

  const [loading, setLoading] = useState(false);

  const [gsterror, setGstError] = useState("");
  const [cinerror, setCinError] = useState("");
  const [panerror, setPANError] = useState("");

  const [uploads, setuploads] = useState({
    gst: "",
    msme: "",
    pan: "",
    cin: "",
  });

  const { gst, msme, pan, cin } = uploads;

  const handleLogoChange = async (e) => {
    setLoading(true);
    try {
      const file = e.target.files[0];
      if (file) {
        setLogoImgPreview(file);
        const formData = new FormData();
        formData.append("companyDocument", file);
        formData.append("companyDocumentType", "MSME");
        const response = await AddDocumentMSME(formData);
        if (response) {
          toastSuccess(response?.message);
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    const gstRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    const cinRegex = /^[LU]\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}$/;

    let errorMsg = "";

    if (name === "gst") {
      errorMsg = gstRegex.test(value)
        ? "Valid GST Number"
        : "Invalid GST Number";
      setGstError(errorMsg);
    } else if (name === "cin") {
      errorMsg = cinRegex.test(value) ? "Valid CIN" : "Invalid CIN";
      setCinError(errorMsg);
    } else {
      errorMsg = panRegex.test(value) ? "Valid PAN" : "Invalid PAN";
      setPANError(errorMsg);
    }

    setuploads((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSumbit = async () => {
    try {
      // if (logoImgPreview) {
      //   const formData = new FormData();
      //   formData.append("companyDocument", logoImgPreview);
      //   formData.append("companyDocumentType", "MSME");
      //   const response = await AddDocumentMSME(formData);
      //   if (response) {
      //     toastSuccess(response?.message);
      //   }
      // } else {

      if (!gst && !cin && !pan) {
        toastError("Please provide at least one of GST, CIN, or PAN.");
        return; // stop execution if no data
      }

      const datas = {
        companyGST: gst || "",
        companyCIN: cin || "",
        companyPAN: pan || "",
      };

      const response = await AddDocumentDetails(datas);
      if (response) {
        toastSuccess(response?.message);
      } else {
        toastError(response?.errors?.[0] || "Something went wrong.");
      }

      // }
    } catch (error) {
      toastError("An unexpected error occurred.");
    }
  };

  useEffect(() => {
    if (profileData) {
      setLogoImgPreview(profileData?.companyDocument);
      setuploads({
        ...uploads,
        gst: profileData?.companyGST,
        cin: profileData?.companyCIN,
        pan: profileData?.companyPAN,
      });
    }
  }, [profileData]);

  useEffect(() => {}, [profileData]);

  return (
    <div className="mb-5 default-form">
      <div>
        <Row>
          <Col lg="12">
            <div className="form-group">
              <label>
                MSME Certificate{" "}
                <span style={{ color: "grey", fontSize: "13px" }}>
                  (Company Proof Docs)
                </span>
              </label>

              <div>
                <input
                  type="file"
                  style={{
                    display: "none",
                  }}
                  id="uploadmsme-doc"
                  onChange={handleLogoChange}
                  accept=".jpg,.jpeg,.png,.tiff,.tif,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                  //   accept="application/pdf,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                />
              </div>

              <label
                className="uploadButton-button ripple-effect"
                htmlFor="uploadmsme-doc"
                style={{
                  border: "1px dashed grey",
                  width: "100%",
                  height: "130px",
                  padding: "5px",
                  borderRadius: "10px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                {loading ? (
                  <>
                    <div>
                      {" "}
                      <span className="spinner">
                        <i class="fa-solid fa-spinner spinner"></i>
                      </span>{" "}
                      Uploading File
                    </div>
                  </>
                ) : (
                  <>
                    {logoImgPreview ? (
                      <>
                        <span style={{ color: "grey", fontSize: "40px" }}>
                          {" "}
                          <i class="fa-solid fa-cloud-arrow-up"></i>
                        </span>
                        <div
                          className="mt-3"
                          style={{
                            color: "grey",
                            fontSize: "14px",
                            textAlign: "center",
                          }}
                        >
                          {logoImgPreview?.name ? (
                            <>{logoImgPreview?.name}</>
                          ) : (
                            <>
                              {logoImgPreview.split("/").slice(-1)[0]}
                              {/* <img
                            src={logoImgPreview}
                            width={"50px"}
                            height={"50px"}
                          /> */}
                            </>
                          )}
                        </div>
                      </>
                    ) : (
                      <>
                        <span style={{ color: "grey", fontSize: "40px" }}>
                          {" "}
                          <i class="fa-solid fa-cloud-arrow-up"></i>
                        </span>
                        <div
                          className="mt-3"
                          style={{
                            color: "grey",
                            fontSize: "14px",
                            textAlign: "center",
                          }}
                        >
                          Supported: JOG,JPEG,PNG,TIFF,PDF,TIF,X2SX,XLS | File
                          Size should be min .5mb
                        </div>
                      </>
                    )}
                  </>
                )}
              </label>
            </div>
          </Col>
        </Row>
      </div>
      <div>
        <Row>
          <Col lg={4}>
            <div className="form-group">
              <label>GST</label>
              <input
                type="text"
                name="gst"
                placeholder="eg 27AAAPA********"
                value={gst}
                onChange={handleChange}
              />

              <div>
                {gsterror === "Valid GST Number" ? (
                  <div className="text-success mt-2">Valid GST Number</div>
                ) : (
                  <div className="text-danger mt-2">{gsterror}</div>
                )}
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div className="form-group">
              <label>Company PAN</label>
              <input
                type="text"
                name={"pan"}
                placeholder="eg AAAPA*****"
                value={pan}
                onChange={handleChange}
              />

              <div>
                {panerror === "Valid PAN" ? (
                  <div className="text-success mt-2">Valid PAN</div>
                ) : (
                  <div className="text-danger mt-2">{panerror}</div>
                )}
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div className="form-group">
              <label>
                CIN{" "}
                <span
                  style={{
                    color: "grey",
                    fontSize: "11px",
                  }}
                >
                  {" "}
                  (Corporate Identification Number)
                </span>
              </label>
              <input
                type="text"
                name={"cin"}
                placeholder="eg L01631KA2************"
                value={cin}
                onChange={handleChange}
              />
              <div>
                {cinerror === "Valid CIN" ? (
                  <div className="text-success mt-2">Valid CIN</div>
                ) : (
                  <div className="text-danger mt-2">{cinerror}</div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div>
        <div className="form-group col-lg-6 col-md-12 d-flex align-items-center justify-content-center w-100">
          <button className="theme-btn btn-style-one" onClick={handleSumbit}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default DocumentUploadBox;
